<template>
  <div class="section section-center">
    <div class="login-wrap">
      <Welcome text="Подтверждение Email">
        <div class="text-secondary ts-center">Обрабатываем код подтверждения Email.</div>
      </Welcome>

      <Spinner v-if="isLoading" size="large" />

      <div v-if="success" class="success w-form-done">
        <div>Успешно!</div>
      </div>

      <div v-if="error" class="w-form-fail">
        <div>{{ error }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import Welcome from '@/containers/auth/Welcome';
  import factory from '@/utils/api/factory';
  import Spinner from 'vue-simple-spinner';
  import parseError from '@/utils/api/parse-error';

  export default {
    name: 'ConfirmEmail',
    components: {Welcome, Spinner},
    data () {
      return {
        isLoading: true,
        success: false,
        error: null,
      };
    },
    async created () {
      try {
        await factory('auth').postInPath('confirm', {
          code: this.$route.params.hash,
        });
        this.success = true;
        setTimeout(() => {
          this.$router.push({name: 'login'});
        }, 1500);
      } catch (e) {
        this.error = parseError(e);
      }
      this.isLoading = false;
    },
  };
</script>
